import type { Profile, SupportedOnboardingTourStep } from 'models';
import { useResetQueryMutation } from 'query';
import { useCallback } from 'react';
import { handleAxiosError } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { ConsentsForm } from 'features/consents/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useConsentsQuery } from 'features/consents/queries';
import { useUpdateOnboardingStepMutation } from '../../../queries';
import { ConsentsStepSkeleton } from './consents-step-skeleton';

type P = {
  onConsent: (id?: string) => void;
  onSuccess: () => void;
  step: SupportedOnboardingTourStep;
  viewer: Profile;
};

const ConsentsStep = ({ onConsent, onSuccess, step, viewer }: P) => {
  const { data: consents, isLoading: isLoadingConsents } = useConsentsQuery({
    consentIds: viewer.requiredConsents.map((consent) => consent.id),
  });
  const { mutateAsync: resetQuery } = useResetQueryMutation();
  const { mutateAsync: updateStep } = useUpdateOnboardingStepMutation();

  const onAccept = useCallback(async () => {
    try {
      await updateStep({ id: step.data.id, status: 'completed' });
      await resetQuery({ cacheResetOption: 'invalidate' });
      onSuccess();
    } catch (error) {
      if (error instanceof Error) {
        handleAxiosError(error);
      }
    }
  }, [onSuccess, resetQuery, step.data.id, updateStep]);

  if (isLoadingConsents || !consents) {
    return <ConsentsStepSkeleton />;
  }

  return (
    <ConsentsForm
      consents={consents}
      currentAcceptedConsents={viewer.usersConsents}
      entities={[]}
      onAccept={onAccept}
      onConsent={onConsent}
      showInfoMessage={false}
      showTitle={false}
      submit={{ block: true }}
    />
  );
};

export default ConsentsStep;
